import MyAxios from "@/utilize/MyAxios";
import { useMutation, useQuery } from "@tanstack/react-query";

export type TCheckoutLinkPayload = {
  items: {
    price: string;
    quantity: number;
  }[];
  coupon?: string;
};

export default function useGetCheckoutLink() {
  return useMutation({
    mutationFn: ({
      payload,
      organizationId,
    }: {
      payload: TCheckoutLinkPayload;
      organizationId: string;
    }) =>
      MyAxios.post<{ url: string }>(
        `/billing/${organizationId}/checkout-link`,
        payload,
      ).then((res) => res.data),
  });
}

export type TUpgradeSubscriptionPayload = {
  priceId: string;
  incrementQuantity: number;
  coupon?: string;
};

export function useUpgradeSubscription() {
  return useMutation({
    mutationFn: ({
      payload,
      organizationId,
    }: {
      payload: TUpgradeSubscriptionPayload;
      organizationId: string;
    }) =>
      MyAxios.patch<{ link: string }>(
        `/billing/${organizationId}/upgrade-subscription`,
        payload,
      ).then((res) => res.data),
  });
}

type BillingAdjustment = {
  amountDue: number;
  currency: string;
  lineItems: LineItem[];
};

type LineItem = {
  totalCount: number;
  data: LineItemDetail[];
};

type LineItemDetail = {
  amount: number;
  currency: string;
  description: string;
  quantity: number;
  subtotal: number;
};

export function useGetBillingProrationPreview(params: {
  organizationId: string;
  priceId: string;
  incrementQuantity?: number;
}) {
  return useQuery({
    queryKey: ["prorationPreview", params],
    enabled: !!params.organizationId && !!params.priceId,
    queryFn: () =>
      MyAxios.get<BillingAdjustment>(
        `/billing/${params.organizationId}/proration-preview`,
        {
          params: {
            priceId: params.priceId,
            incrementQuantity: params.incrementQuantity,
          },
        },
      ).then((res) => res.data),
  });
}
